import React from 'react';
import Button from 'components/Button';
import {ButtonProps} from '@mui/material';

export const PrimaryButton = (props: ButtonProps) => <Button color="primary" {...props} />;
